import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ items, className = "" }) => (
  <div className={`border-y border-black/5 py-8 bg-blush/40 overflow-hidden ${className}`} data-testid="editorial-marquee">
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="mx-10 inline-flex items-center gap-10">
          <span className="font-serif italic text-3xl sm:text-5xl text-charcoal/80 tracking-tight whitespace-nowrap">
            {t}
          </span>
          <span className="text-rosegold text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export const SlimMarquee = ({ items, href }) => (
  <div className="bg-blush/60 border-y border-black/5 py-3.5 overflow-hidden" data-testid="insta-marquee">
    <Marquee speed={34} gradient={false} autoFill>
      {items.map((t, i) => (
        <a
          key={i}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="mx-7 inline-flex items-center gap-3 text-[0.7rem] uppercase tracking-[0.28em] text-charcoal/70 hover:text-rosegold transition-colors duration-300"
        >
          {t}
          <span className="text-rosegold">✦</span>
        </a>
      ))}
    </Marquee>
  </div>
);
